import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, message } from "antd";
import * as api from "../../../utils/api";
import { LoadingIndicator } from "../../../components/loading";
import { PageLayout } from "../../../components/page-layout";
import * as S from "./styles";
import { UpdateStorePasswordModal } from "../../../components/update-store-password-modal";
import { UpdateStoreModal } from '../../../components/update-store-modal';

const DEFAULT_ERROR_MESSAGE =
  "Erro inesperado. Por favor, tente novamente mais tarde.";

export const StoreDetailsPage = () => {
  const navigate = useNavigate();
  const { storeId } = useParams();

  const [loading, setLoading] = useState(true);
  const [store, setStore] = useState(null);
  const [openUpdatePassword, setOpenUpdatePassword] = useState(false);
  const [openUpdateInfo, setOpenUpdateInfo] = useState(false);

  const handleGetCurrentActiveCampaign = useCallback(async () => {
    setLoading(true);

    try {
      const { result, error } = await api.post("/get-store", {
        storeId,
      });

      if (error) {
        throw new Error(error);
      }

      setStore(result || null);
    } catch (err) {
      message.error(err.message || DEFAULT_ERROR_MESSAGE);
      setStore(null);
    } finally {
      setLoading(false);
    }
  }, [storeId]);

  const handleUpdateStore = async (payload) => {
    try {
      const { error } = await api.post("/update-store", {
        ...payload,
        cnpj: payload.cnpj.replace(/\D/g, ''),
        storeId,
      });

      if (error) throw new Error(error);

      message.success("Informações atualizadas com sucesso!");
      handleGetCurrentActiveCampaign();
      setOpenUpdateInfo(false);
    } catch (err) {
      message.error(err.message || DEFAULT_ERROR_MESSAGE);
    }
  };

  const handleUpdateStorePassword = async ({ newPassword }) => {
    try {
      const { result, error } = await api.post("/update-store-password", {
        storeId,
        newPassword,
      });

      if (error) {
        throw new Error(error);
      }

      setOpenUpdatePassword(false);
      message.success("Senha atualizada com sucesso!");
      await handleGetCurrentActiveCampaign();
    } catch (err) {
      message.error(err.message || DEFAULT_ERROR_MESSAGE);
    }
  };


  useEffect(() => {
    handleGetCurrentActiveCampaign();
  }, [handleGetCurrentActiveCampaign]);

  if (loading) {
    return <LoadingIndicator />;
  }

  if (!store) {
    return (
      <PageLayout>
        <S.Container>
          <div id="go-back-container">
            <Button type="primary" onClick={() => navigate(-1)} id="app-button">
              Voltar
            </Button>
          </div>
          <h3 style={{ textAlign: 'center', marginTop: 20 }}>
            Concessionária não encontrada
          </h3>
        </S.Container>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <S.Container>
        <div id="go-back-container">
          <Button type="primary" onClick={() => navigate(-1)} id="app-button">
            Voltar
          </Button>
          
          <Button 
            style={{ marginLeft: 8 }}
            onClick={() => setOpenUpdateInfo(true)}
          >
            Editar Informações
          </Button>
          <Button 
            style={{ marginLeft: 8 }}
            onClick={() => setOpenUpdatePassword(true)}
          >
            Alterar Senha
          </Button>
        </div>

        <S.Wrapper>
          <div id="store-details-container">
            <div
              style={{
                marginBottom: 16,
                paddingBottom: 8,
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <h3>Concessionária</h3>
            </div>

            <S.StoreInputContainer>
              <span>Nome:</span>
              <span>{store?.title}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>CNPJ:</span>
              <span>{store?.cnpj}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>Telefone:</span>
              <span>{`(${store?.area_code}) ${store?.phone_number}`}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>Endereço:</span>
              <span>{store?.address}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>Bairro:</span>
              <span>{store?.neighborhood}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>Estado:</span>
              <span>{store?.state}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>Cidade:</span>
              <span>{store?.city}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>CEP:</span>
              <span>{store?.postal_code}</span>
            </S.StoreInputContainer>
          </div>
          <div id="marketing-contact-container">
            <div
              style={{
                marginBottom: 16,
                paddingBottom: 8,
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <h3>Contato Marketing</h3>
            </div>

            <S.StoreInputContainer>
              <span>Nome:</span>
              <span>{store?.contact_name}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>E-mail:</span>
              <span>{store?.contact_email}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>Telefone:</span>
              <span>{store?.contact_phone}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>Grupo:</span>
              <span>{store?.contact_group}</span>
            </S.StoreInputContainer>

            <S.StoreInputContainer>
              <span>Consultor Comercial:</span>
              <span>{store?.contact_consultant}</span>
            </S.StoreInputContainer>
          </div>
        </S.Wrapper>

        <UpdateStoreModal
          open={openUpdateInfo}
          onCancel={() => setOpenUpdateInfo(false)}
          onSubmit={handleUpdateStore}
          initialValues={store}
        />
        
        <UpdateStorePasswordModal
          open={openUpdatePassword}
          onCancel={() => setOpenUpdatePassword(false)}
          onSubmit={handleUpdateStorePassword}
        />
      </S.Container>
    </PageLayout>
  );
};
